<div class="modal-wrapper">
  <div class="container">
    <div class="spinner-container">
      <itl-loading-indicator [delay]="0"></itl-loading-indicator>
    </div>
    <div class="text-container">
      <div class="message">{{ message }}</div>
      <div class="subtitle" *ngIf="subtitle">{{ subtitle | async }}</div>
    </div>
  </div>
  <div class="separator" *ngIf="showCancelButton"></div>
  <div class="button-container" *ngIf="showCancelButton">
    <button class="cancel-button" (click)="close()">{{ 'CANCEL_BUTTON' | translate }}</button>
  </div>
</div>
